import { extendTailwindMerge } from 'tailwind-merge';

import { tailwindMergeConfig } from './mergeConfig';

export const tailwindMerge = extendTailwindMerge({
  extend: {
    ...tailwindMergeConfig,
  },
});
